"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var SocialIcons_1 = tslib_1.__importDefault(require("../SocialIcons"));
var SocialFollowUs = function (_a) {
    var _b = _a.config, config = _b === void 0 ? {} : _b, className = _a.className, variant = _a.variant, _c = _a.size, size = _c === void 0 ? 32 : _c;
    if (!variant) {
        return null;
    }
    var configKeys = Object.keys(config).filter(function (c) {
        return !!config[c].url;
    });
    return (React.createElement(SocialIcons_1["default"], { className: className, icons: configKeys, size: size, variant: variant, renderIcon: function (icon, children) { return (React.createElement("a", { href: config[icon].url, target: "_blank", rel: "noopener noreferrer" }, children)); } }));
};
exports["default"] = SocialFollowUs;
